import firebaseApp from 'firebase/app'
import 'firebase/auth'
import db from './db'

export const fbAuth = firebaseApp.auth
const googleProvider = new fbAuth.GoogleAuthProvider()

export default {
  getIdToken () {
    return fbAuth().currentUser.getIdToken()
  },
  signUp (email, password, callback) {
    fbAuth().createUserWithEmailAndPassword(email, password).then(
      () => (callback(null)),
      (err) => (callback(err))
    )
  },
  signIn (email, password, callback) {
    fbAuth().signInWithEmailAndPassword(email, password).then(
      () => (callback(null)),
      (err) => (callback(err))
    )
  },
  signOut (anonymous, uid, callback) {
    let promise = new Promise((resolve) => {
      if (anonymous) {
        db.dashboards.clearAnonymousData(uid, () => {
          resolve()
        })
      } else {
        resolve()
      }
    })

    promise.then(() => {
      fbAuth().signOut()
        .then(() => (callback(null)))
        .catch((err) => (callback(err)))
    })
  },
  signInWithProvider (provider) {
    fbAuth().signInWithPopup(provider)
      .catch((err) => (console.log(err)))
  },
  signInWithGoogle () {
    this.signInWithProvider(googleProvider)
  },
  signInWithToken (token) {
    fbAuth().signInWithCustomToken(token)
  },
  signInAsAnonymously (callback) {
    fbAuth().signInAnonymously()
      .then(() => {
        callback(null)
      })
      .catch((err) => {
        callback(err)
      })
  },
  signUpAnonymous (data, callback) {
    let oldUser = fbAuth().currentUser

    fbAuth().createUserWithEmailAndPassword(data.email, data.password).then(
      (result) => {
        oldUser.delete()

        let oldUid = data.uid
        let newUid = result.user.uid

        db.dashboards.replaceOwner(oldUid, newUid, () => {
          callback()
        })
      },
      (err) => (callback(err))
    )
  },
  signUpAnonymousWithGoogle (data, callback) {
    let oldUser = fbAuth().currentUser

    fbAuth().signInWithPopup(googleProvider)
      .then((result) => {
        oldUser.delete()

        let oldUid = data.uid
        let newUid = result.user.uid

        db.dashboards.replaceOwner(oldUid, newUid, () => {
          callback()
        })
      })
      .catch((err) => (callback(err)))
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js